import * as schema from "@/shared/state/visualization/schema/v1/three-d";

/**
 * Pick a default entity to target when the camera spec does not name
 * one. Used by the mode toggle (orbit → thirdPerson seed) and the
 * recenter button (third-person → orbit-style framing reset). Prefers
 * the first entity with a mesh; falls back to the first with a path.
 * Returns `undefined` when no entity carries either.
 */
export function resolveFallbackEntity(
  entities: Record<schema.EntityID, schema.Entity>,
): { id: schema.EntityID; mesh: "mesh" | "path" } | undefined {
  for (const [id, entity] of Object.entries(entities)) {
    if (entity.mesh) {
      return { id, mesh: "mesh" };
    }
    if (entity.path) {
      return { id, mesh: "path" };
    }
  }
  return undefined;
}
